import { useCallback } from 'react'
import { getNormalizedFileName } from 'ComponentLibrary/src/common/file'

type UseDownloadFileProps = {
    file: FileProps | undefined
}

type FileUrlAndName = { url: string; name: string; content_type?: string }

type FileProps = FileUrlAndName & { content_type: string }

export function useForceDownloadFile({ file }: UseDownloadFileProps) {
    return useCallback(
        () => file?.url && forceDownloadFile({ url: file.url, name: file.name, content_type: file.content_type }),
        [file?.name, file?.url, file?.content_type]
    )
}

const forceDownloadFile = ({ url, name, content_type }: { url: string; name: string; content_type: string }) => {
    void fetch(url).then((response) => {
        void response.blob().then((blob) => {
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(new Blob([blob]))
            link.download = getNormalizedFileName({ name, content_type })
            link.click()
            link.remove()
        })
    })
}

export function useDownloadFileParameterized() {
    return useCallback((file: FileUrlAndName) => file?.url && forceDownloadFileWithExtension(file), [])
}

const forceDownloadFileWithExtension = async ({ url, name, content_type }: FileUrlAndName) => {
    const response = await fetch(url)
    if (!response.ok) {
        throw new Error(`HTTP error while downloading file: ${url}, name: ${name}. Status code: ${response.status}`)
    }

    try {
        const blob = await response.blob()

        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = getNormalizedFileName({ name, content_type })
        link.click()
        link.remove()
    } catch (err) {
        throw new Error(`Failed to download file: ${url}, name: ${name}`, { cause: err })
    }
}
